import { render, staticRenderFns } from "./operateArea.vue?vue&type=template&id=64b8d1bd&scoped=true"
import script from "./operateArea.vue?vue&type=script&lang=js"
export * from "./operateArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b8d1bd",
  null
  
)

export default component.exports